export default "__VITE_ASSET__FCxkWlLD__"